import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "../../contexts";
import { ClaimStakeSuccessScreen } from "../claim-staking-request/components/ClaimStakeSuccessScreen";
import { getStakeTransactionDetail } from "../../services/app";
import { formatDateTime } from "../../utils/date";
import { LoadingSplash2 } from "../../components/Loading2";
import * as Notification from "../../Notification";

export const ClaimStakeSuccess = () => {
  const { T, loading } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [stakeData, setStakeData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStakeDetail = async () => {
      setIsLoading(true);

      const stakeRecordId = searchParams.get("stakeRecordId");

      if (stakeRecordId) {
        const res = await getStakeTransactionDetail(stakeRecordId);
        if (res.status === 200 && res?.data) {
          setStakeData(res.data);
        } else {
          Notification.error(T("Failed to fetch stake detail"));
          console.error("Error fetching stake detail:", res.data);
        }
      }

      setIsLoading(false);
    };

    fetchStakeDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleBackHome = () => {
    navigate("/");
  };

  if (isLoading || loading) {
    return <LoadingSplash2 />;
  }

  if (!stakeData) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-center py-10">{T("Stake information not found")}</p>
        <button
          onClick={handleBackHome}
          className="mt-4 px-4 py-2 border border-black rounded-[15px]"
        >
          {T("Back to Home")}
        </button>
      </div>
    );
  }

  // Map stakeData to claimData format
  const claimAmount = stakeData?.claimAmount || 0;
  const claimAmountDisplay = `${claimAmount} SGT`;
  
  // Format claim date from API data
  const claimDate = formatDateTime(stakeData?.claimedAt);
  
  // Get transaction hash from API data
  const transactionHash = 
    stakeData?.claimTxHash || 
    "";

  return (
    <ClaimStakeSuccessScreen
      T={T}
      claimAmount={claimAmountDisplay}
      claimDate={claimDate}
      transactionHash={transactionHash}
      onPrimaryAction={handleBackHome}
    />
  );
};

